var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Map",attrs:{"data-cy":"map"}},[_c('l-map',{ref:"map"},[_c('l-tile-layer',{attrs:{"url":_vm.url,"attribution":_vm.attribution}}),_vm._t("marker"),_vm._t("content")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }